<template>
  <form @submit.prevent="onAssign" class="mb-3">
    <select v-model="user_id" class="form-select mb-2">
      <option disabled value="">Usuario</option>
      <option v-for="u in users" :value="u.id" :key="u.id">{{ u.name }}</option>
    </select>
    <select v-model="device_id" class="form-select mb-2">
      <option disabled value="">Dispositivo</option>
      <option v-for="d in devices" :value="d.id" :key="d.id">{{ d.name }}</option>
    </select>
    <button class="btn btn-warning btn-sm w-100" type="submit">Asignar</button>
    <span v-if="msg" style="color:green">{{ msg }}</span>
  </form>
</template>
<script>
import api from "../api/api";
export default {
  props: ["users", "devices"],
  data() {
    return { user_id: "", device_id: "", msg: "" };
  },
  methods: {
    async onAssign() {
      await api.assignDevice({
        user_id: this.user_id,
        device_id: this.device_id,
      });
      this.msg = "Asignado";
      this.user_id = this.device_id = "";
      this.$emit("assigned");
    },
  },
};
</script>
